module.exports = "/images/minus.svg?dd1d8ad071cb925a17e1d01c2cb849c1";